import { render } from "./UpdateBus.vue?vue&type=template&id=bd8e45a8"
import script from "./UpdateBus.vue?vue&type=script&lang=js"
export * from "./UpdateBus.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__